/**
 * Star Field — Procedural canvas background shown during Earth↔Moon transitions.
 *
 * 200 stars with subtle parallax drift. Only runs the rAF loop when visible
 * (controlled by .star-field class on <body>).
 */

let canvas = null;
let ctx = null;
let stars = [];
let animating = false;
let rafId = null;

const STAR_COUNT = 200;

/**
 * Initialize the star field canvas. Call once at app startup.
 * The canvas is hidden by default; shown when body gets .star-field class.
 */
function initStarfield() {
  canvas = document.createElement('canvas');
  canvas.id = 'starfield-canvas';
  document.body.appendChild(canvas);

  ctx = canvas.getContext('2d');

  // Generate stars with random positions, sizes, and brightness
  resize();
  generateStars();

  // Watch for the .star-field class toggle to start/stop animation
  const observer = new MutationObserver(() => {
    const visible = document.body.classList.contains('star-field');
    if (visible && !animating) {
      startAnimation();
    } else if (!visible && animating) {
      stopAnimation();
    }
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });

  // Handle window resize
  window.addEventListener('resize', () => {
    resize();
    generateStars();
  });
}

function resize() {
  if (!canvas) return;
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
}

function generateStars() {
  stars = [];
  const w = canvas.width;
  const h = canvas.height;

  for (let i = 0; i < STAR_COUNT; i++) {
    stars.push({
      x: Math.random() * w,
      y: Math.random() * h,
      r: 0.5 + Math.random() * 1.5,      // radius 0.5–2px
      opacity: 0.3 + Math.random() * 0.7, // opacity 0.3–1.0
      drift: 0.02 + Math.random() * 0.03, // parallax speed px/frame
    });
  }
}

function startAnimation() {
  animating = true;
  rafId = requestAnimationFrame(draw);
}

function stopAnimation() {
  animating = false;
  if (rafId) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
}

function draw() {
  if (!animating) return;

  const w = canvas.width;
  const h = canvas.height;

  ctx.clearRect(0, 0, w, h);
  ctx.fillStyle = '#000008';
  ctx.fillRect(0, 0, w, h);

  for (const star of stars) {
    // Subtle rightward drift (parallax)
    star.x += star.drift;
    if (star.x > w + 2) star.x = -2;

    ctx.beginPath();
    ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
    ctx.fillStyle = `rgba(220, 225, 240, ${star.opacity})`;
    ctx.fill();
  }

  rafId = requestAnimationFrame(draw);
}

export { initStarfield };
